import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {fetchDatingTopics, resetDatingTopics} from "../../../creators/dating.topics";
import {fetchLocationRegionsFR} from "../../../creators/locations.regionsFR";

import Title from "../../components/Title";
import {Button, ButtonGroup} from "../../components/Button";
import {config} from "../../../config";
import {LoadingBar, PageLoader} from "../../components/Loader";
import MeetArround from "./components/MeetArround";
import Carousel from "../../components/Carousel";
import Dropdown from "../../components/Dropdown";
import Icon from "../../components/Icon";
// import Aqp from "../../../libs/mk-react-aqp";
// import createLink from "../../../libs/createLink";
//
// let mapping = {
//     'owner.profile.gender': 'gender',
//     'sortBy' : 'trie-topic'
// };


class ForumsMeet extends React.Component {
    constructor(props) {
        super(props);
        this.forumSexOrientation = ["hetero", "homo"];
        this.topicsFilter = {
            "owner.profile.gender": [],
            displayDating: true,
            sort: "-createdAt",

            selectedRegion: [],
            limit: 18,
            currentPaneIndex: 0,
            isHomo: false,
            isTotal : false
        };
        // this.aqpTopic = new Aqp(mapping, {
        //     blacklist: [
        //         'limit',
        //         'page',
        //         'displayDating',
        //         'currentPaneIndex',
        //         'sortBy'
        //     ],
        //     currentLink: createLink("dating")
        // });
        this.state = {
            topicsFilter: {...this.topicsFilter},
            toggleSortByFilters: false,
            currentOrientation: "hetero",
        };

        this.getDatingTopics = this.getDatingTopics.bind(this);
        this.handleGender = this.handleGender.bind(this);
        this.handleOrientation = this.handleOrientation.bind(this);
        this.handleLocationSelection = this.handleLocationSelection.bind(this);
        this.handleSubmitTopicsFilter = this.handleSubmitTopicsFilter.bind(this);

        this.getDatingTopics(this.state.topicsFilter);
        this.props.fetchLocationRegionsFR({sort: "-createdAt", parentCode: "fr", limit: false});
    }

    componentWillUnmount() {
        this.props.resetDatingTopics();
        this.setState({topicsFilter: this.topicsFilter})
    }

    getDatingTopics(filter) {
        let query = {...filter};
        this.props.fetchDatingTopics(query);
    }

    handleGender(value) {
        let tags = this.state.topicsFilter["owner.profile.gender"];
        let newTags = [...tags];

        if (!tags.includes(value)) {
            newTags.push(value);
        } else {
            newTags = tags.filter(item => value !== item);
        }

        let topicsFilter = {...this.state.topicsFilter, "owner.profile.gender": newTags};

        this.setState({topicsFilter});
    }

    handleOrientation(value) {
        let topicsFilter = {
            ...this.state.topicsFilter,
            isHomo: value === "homo" ? true : false
        };

        this.setState({topicsFilter , currentPaneIndex: 0, currentOrientation : value});
    }

    handleLocationSelection(name) {
        let location = this.state.topicsFilter.selectedRegion;
        name = name.replace('Région ', "");
        if (location.includes(name)) {
            location = location.filter(item => item !== name);
        } else {
            location.push(name);
        }
        let newLocation = {...this.state.topicsFilter, selectedRegion: location};
        this.setState({topicsFilter: newLocation, currentRegion: 0});
    }

    handleSubmitTopicsFilter() {
        this.props.fetchDatingTopics(this.state.topicsFilter);
    }

    render() {
        let gender = Array.isArray(this.state.topicsFilter["owner.profile.gender"]) ? this.state.topicsFilter["owner.profile.gender"] : [this.state.topicsFilter["owner.profile.gender"]];
        let regions = [{_id : "domtom", name: "DOM-TOM"}, {_id : "belgique", name: "Belgique"}, {_id : "suisse", name: "Suisse"}, {_id : "quebec", name: "Québec"}, ...this.props.regions];

        return (
            <div className="forum-card-carousel mt-24">
                <div className="row align-center justify-space-between wrap">
                    <Title className={"forum-cardlist-title"} heading={"heading-1"} display={"display-2"}>Les annonces
                        de rencontre du forum</Title>
                    {/*<div className="row">*/}
                    {/*    <Button className="ml-8"*/}
                    {/*            size={"medium"}*/}
                    {/*            btnStyle={"primary-reverse"}*/}
                    {/*            to="/forum/5c34b9caeeebd537640c3190-rencontres-coquines"*/}
                    {/*            content={"Voir toutes les annonces"}/>*/}
                    {/*</div>*/}
                </div>
                <div className="forum-announce-filters-wrapper">
                    <h3 className={`title-sort-by ${this.state.toggleSortByFilters ? 'active' : ''}`}
                        onClick={() => this.setState({toggleSortByFilters: !this.state.toggleSortByFilters})}>Trier
                        Par <Icon type={"chevron-down"}/></h3>
                    <div
                        className={`row wrap forum-announce-filters ${this.state.toggleSortByFilters ? 'active' : ''}`}>
                        <div className="column mr-16">
                            <ButtonGroup>
                                {config.genderList.map((item, genderIndex) => {
                                    if (genderIndex > 0) {
                                        return <Button key={genderIndex}
                                                       size={"small"}
                                                       active={gender.includes(genderIndex)}
                                                       onClick={() => this.handleGender(genderIndex)}
                                                       content={item}/>
                                    } else return null;
                                })}
                            </ButtonGroup>
                        </div>
                        <div className="column mr-16">
                            <ButtonGroup>
                                {this.forumSexOrientation.map((item, index) => (
                                    <Button key={index}
                                            active={this.state.currentOrientation === item}
                                            onClick={() => this.handleOrientation(item)}
                                            content={item}/>
                                ))}
                            </ButtonGroup>
                        </div>
                        <div className="column mr-16 flex-1">
                            <div className="row wrap">
                                <Dropdown align="right filter-list" activableComponent={(
                                    <Button className={"select-location-btn"}
                                            size={"small"}
                                            icon={"chevron-down"}
                                            iconSide={"right"}
                                            content={"Choisir la localisation"}/>
                                )}>
                                    <ul className="dropdown-menu select-region-menu">
                                        {regions.map(item =>{
                                            let name = item.name || "";
                                            name = name.replace('Région ', "");
                                            return (
                                                <li key={item._id}
                                                    onClick={() => this.handleLocationSelection(item.name)}
                                                    className={`menu-item ${this.state.topicsFilter.selectedRegion.includes(name) ? 'active' : ''}`}>{item.name}</li>)}
                                            )
                                        }

                                    </ul>
                                </Dropdown>
                            </div>
                        </div>
                        <div className={"row-search"}>
                            <div className={"search"}>
                                <Button size={"small"}
                                        btnStyle={"primary-reverse"}
                                        onClick={() => this.handleSubmitTopicsFilter()}
                                        content={"Ok"}/>
                            </div>

                        </div>

                    </div>
                    {this.state.topicsFilter.selectedRegion.length >= 1 && (
                        <div className="row wrap region-display">
                            {this.state.topicsFilter.selectedRegion.map((regions, index) => (
                                <div key={index} className="region-block">{regions}<span
                                    onClick={() => this.handleLocationSelection(regions)}><Icon
                                    type="close"/></span></div>
                            ))}
                        </div>
                    )}
                </div>
                {this.props.datingTopicsInitialized && this.props.datingTopicsLoading && (
                    <LoadingBar />
                )}
                {!this.props.datingTopicsInitialized ? (
                    <PageLoader/>
                ) : (
                    this.props.datingTopicsLength === 0 ? (
                            <div className="no-content">Aucune annonce à afficher</div>
                    ) : (
                        <Carousel
                            hideArrowsControls={this.props.datingTopicsLength <= 6}
                            currentPaneIndex={this.state.currentPaneIndex}>
                            <div className={`pane ${this.props.datingTopics && this.props.datingTopicsLength === 0 ? 'no-article' : ''}`}>
                                <div className="row wrap">
                                    {Array.isArray(this.props.datingTopics) && this.props.datingTopics.slice(0, 6).map(item => (
                                        <MeetArround key={item._id}
                                                     {...item}
                                                     datingTopicsInitialized={this.props.datingTopicsInitialized}
                                                     datingTopicsLoading={this.props.datingTopicsLoading}
                                                     genderClass={config.genderClass}/>
                                    ))}
                                </div>
                            </div>
                            {this.props.datingTopicsLength > 6 && (
                                <div className="pane">
                                    <div className="row wrap">
                                        {Array.isArray(this.props.datingTopics) && this.props.datingTopics.slice(6, 12).map(item => (
                                            <MeetArround key={item._id}
                                                         {...item}
                                                         datingTopicsInitialized={this.props.datingTopicsInitialized}
                                                         datingTopicsLoading={this.props.datingTopicsLoading}
                                                         genderClass={config.genderClass}/>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {this.props.datingTopicsLength > 12 && (
                                <div className="pane">
                                    <div className="row wrap">
                                        {Array.isArray(this.props.datingTopics) && this.props.datingTopics.slice(12, 18).map(item => (
                                            <MeetArround key={item._id}
                                                         {...item}
                                                         datingTopicsInitialized={this.props.datingTopicsInitialized}
                                                         datingTopicsLoading={this.props.datingTopicsLoading}
                                                         genderClass={config.genderClass}/>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </Carousel>
                    )
                )}
            </div>
        )
    }
}



const mapStateToProps = (state) => {
    return {
        datingTopics: state.datingTopics.data,
        datingTopicsLoading: state.datingTopics.loading,
        datingTopicsInitialized: state.datingTopics.initialized,
        datingTopicsLength: state.datingTopics.data.length,
        regions: state.locationRegionsFR.data,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchDatingTopics,
    resetDatingTopics,

    fetchLocationRegionsFR,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForumsMeet);